
import { defineComponent } from "vue"

export default defineComponent({
  setup() {
    const executeButton = () => {
      window.location.href = "https://www.autocall.ai"
    }
    return {
      executeButton,
    }
  },
})
